import { Prospector } from '@clearkit/icons';
import { CKBox, CKIconBox, CKLayoutHorizontal } from 'clearkit';

import { DidYouKnow, GetStarted } from '../CallsToAction';

export const SidebarCTAs = () => {
  return (
    <div className="px-6 py-0.5">
      <CKBox className="p-6" variant="tinted-frame">
        <CKLayoutHorizontal
          className="text-center"
          justifyContent="center"
          wrap="wrap"
        >
          <CKLayoutHorizontal
            className="basis-full shrink-0"
            justifyContent="center"
          >
            <CKIconBox>
              <Prospector />
            </CKIconBox>
          </CKLayoutHorizontal>
          <div className="divide-y divide-gray-200 space-y-8">
            <GetStarted />
            <DidYouKnow className="pt-8" />
          </div>
        </CKLayoutHorizontal>
      </CKBox>
    </div>
  );
};
